import React from 'react'
import { BugReportsFullView } from '../DevOps/BugReports/BugReportsContent'
import { PageContainer } from './PageContainer'

export const BugReportsView = () => (
  <PageContainer fullWidth>
    <BugReportsFullView />
  </PageContainer>
)
